import React, { ReactNode } from 'react';
import styles from './Modal.module.css';
import { createPortal } from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  borderImg?: boolean;
  mountPoint?: 'modal' | 'shop-frame';
  tutorial?: boolean;
}

export const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  onClose, 
  children,
  borderImg,
  mountPoint = 'modal',
  tutorial = false,
}) => {
  if (!isOpen) return null;

  const onCloseHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  }

  const getMountPoint = () => {
    switch (mountPoint) {
      case 'shop-frame':
        return document.getElementById('shop-frame');
      case 'modal':
      default:
        return document.getElementById('modal');
    }
  };

  const element = getMountPoint();
  if (!element) return null;

  return createPortal(
    <div className={`${styles.modalOverlay} ${styles[mountPoint]}`} onClick={onCloseHandler} style={tutorial ? { background: 'rgba(0, 0, 0, 0.8)', backdropFilter: 'blur(9px)' } : {}}>
      <div className={`${styles.modalContent} ${borderImg ? styles.modalImg : ''} ${tutorial ? styles.tutorial : ''}`} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    element
  );
};